/* eslint-disable */
export default {
  infoMessageMins:
    'Guardado automático de inicio de sesión en {delayTime} minutos…',
  infoMessageMin:
    'Guardado automático de inicio de sesión en {delayTime} minuto…',
  infoMessageSecs:
    'Guardado automático de inicio de sesión en {delayTime} segundos…',
  infoMessageSec:
    'Guardado automático de inicio de sesión en {delayTime} segundo…',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
